var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSearchWhite = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M14.925 10.83a4.1 4.1 0 0 0-4.095-4.095 4.1 4.1 0 0 0-4.095 4.095 4.1 4.1 0 0 0 4.095 4.095 4.1 4.1 0 0 0 4.095-4.095m4.68 7.605c0 .64-.53 1.17-1.17 1.17-.311 0-.613-.128-.823-.348l-3.135-3.126A6.432 6.432 0 0 1 4.396 10.83a6.43 6.43 0 0 1 6.434-6.434 6.432 6.432 0 0 1 5.301 10.08l3.135 3.136c.21.21.338.512.338.823z"
})));
export default SvgSearchWhite;